.model-input-point{fill:#e31c3d;pointer-events:none;transform:scale(calc(var(--h3-subpoint-radius) * .6))}
/*# sourceMappingURL=model-input-points.component.css.map */
